import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "https://wuwkpzpiijpkfvwmurrr.supabase.co";
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind1d2twenBpaWpwa2Z2d211cnJyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTExMzA2ODcsImV4cCI6MjA2NjcwNjY4N30.mi22wUKgoO4R_sJPm5cL3NFVP9ivQqSV4sB9r4dJiO0";

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);